import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type ModuleApiInfo } from "@client/content/selectors";
import { parseQueryString } from "@client/lib/api";
import * as React from "react";
import Content, {
  type ActionProps as HelpdeskActionProps,
  type MapProps as HelpdeskMapProps
} from "../MemberHelpdesk/Content/component";
import EmailCheckModal from "./CheckEmailModal/component";

import { useI18n } from "@common/hooks/i18n";
import "./style.less";

export type ActionProps = Omit<HelpdeskActionProps, "onChange"> & {
  onModalSubmit: (email: string) => void;
};
export type MapProps = HelpdeskMapProps & {
  isVisibleSecureModal: boolean;
  obfuscatedEmail: string | null;
  apiInfo: ModuleApiInfo;
};
export type Props = ActionProps & MapProps;

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Container className="wsc_ticket_detail" {...getContainerProps(props)}>
      {/* props.error is init error */}
      {props.error ? (
        <div>{props.error}</div>
      ) : props.detail ? (
        <Content {...props} />
      ) : props.isEditMode ? (
        i18n.infoUseTicketLink
      ) : null}

      <EmailCheckModal
        {...getRootContainerProps(props)}
        isVisible={props.isVisibleSecureModal}
        title="Verify it's you"
        obfuscatedEmail={props.obfuscatedEmail ?? ""}
        onSubmit={(data) => props.onModalSubmit(data["email"])}
        apiInfo={props.apiInfo}
        ticketId={parseQueryString().t}
        scheduleId={parseQueryString().s}
      />
    </Container>
  );
};
